import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var dashboardEntity = function dashboardEntity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_DASHBOARD_SUCCESS:
      return action.response;
    default:
      return state;
  }
};
export default dashboardEntity;